const Chat = require('twilio-chat')
import axios from 'axios'
import store from '@/store'


export default {

    initializing: false,
    listing: false,

    /**
     * Singleton TODO loading w8 for calls
     */
    async initChat () {

      if (!window.yesnoadd) {
        window.yesnoadd = function (purchaseNumber, productId, productViewId, productPrice, productName, mid, shopperId, productQtd){
          console.log(purchaseNumber, productId, productViewId, productPrice, productName, mid, shopperId, productQtd)
          this.acceptProduct(purchaseNumber, productId, productViewId, productPrice, productName, mid, shopperId, productQtd)
        }.bind(this)
      }

      try {
        if ((!window._client_user || window._client_user.connectionState === 'disconnected') && !this.initializing) {
          window._channels = null
          this.initializing = true
          let token = await axios.get(store.getters.getChatApi + '/twilio/token/' + store.state.user.id)
          if (token.data) {
            window._client_user = null
            window._client_user = await Chat.Client.create(token.data.token)
            this.initializing = false
            return true
          } else {
            console.log('Error to get token')
          }
          console.log('chat init')
          this.initializing = false
          return false
        }
      } catch (e) {
        console.log(e)
      }
    },

    async listChannels () {
      try {
        if (!window._client_user ) {
          await this.initChat()
        }
        let paginator = await window._client_user.getSubscribedChannels()
        if (paginator) {
          console.log('load channels')
          await this.updateChannels (paginator.items)
          return window._channels
        } else {
          return {error: true, msg: 'Erro ao listar canais'}
        }
      } catch (e) {
        console.log(e)
        return {error: true, msg: 'Erro ao listar canais'}
      }
    },

    async updateChannels (newChannels) {
      let oldChannels = window._channels
      if (oldChannels) {
        oldChannels.forEach((c) => {
          c.removeListener('messageAdded', this.updateUnreadMessages)
        })
      }
      newChannels.forEach((c) => {
        c.on('messageAdded', this.updateUnreadMessages)
      })
      window._channels = null
      window._channels = newChannels
      console.log('updated channels')
      return true
    },

    updateUnreadMessages (m) {
      console.log(m)
      // TODO atualizar marcadores de mensagens nao lidas
      return m
    },

    async joinToChannel (channelName) {
      try {
        if (!window._client_user || window._client_user.connectionState === 'disconnected') {
          await this.initChat()
        }
        let channel = await axios.post(store.getters.getChatApi + '/twilio/channel/join/' + channelName + '/' + store.state.user.id)
        console.log(channel)
        if (channel.data.channel) {
          return channel.data.channel
        }
      } catch (e) {
        console.log(e)
        return {error: true, msg: 'Erro ao juntat canal', data: e}
      }
    },

    async getChannelByName (channelName) {
      let channels = window._channels
      if (!channels || !channels.length) {
        await this.listChannels()
      }
      let channel = channels.filter(c => c.uniqueName === channelName)[0]
      return channel
    },

    async sendMessageToChannel (channel, message, shopperId, messageType, messageAddInfo) {
      try {
        await channel.sendMessage(message, {company_id: store.getters.getCompanyId, choice_company_id: store.getters.getChoiceCompanyId, user_id: store.state.user.id, shopper_id: shopperId, message_type: messageType, message_add_info: messageAddInfo})
      } catch (e) {
        console.log(e)
      }
    },

    async acceptProduct (yesorno, purchaseNumber, productId, productViewId, productPrice, productName, mid, shopperId, productQtd) {
      try {
        console.log('accepts', yesorno, purchaseNumber, productId, productViewId, productPrice, productName, mid, shopperId, productQtd)
        if (yesorno === 'yes'){  
          //todo invalid mid
          let channel = await this.getChannelByName('channel_' + purchaseNumber)
          await this.sendMessageToChannel(channel, '', shopperId, '_ACCEPT_', {purchaseNumber: purchaseNumber, productId: productId, productViewId: productViewId, productPrice: productPrice, productName: productName, productQtd: productQtd})
        } else {
          //
          let channel = await this.getChannelByName('channel_' + purchaseNumber)
          await this.sendMessageToChannel(channel, '', shopperId, '_REJECT_', {purchaseNumber: purchaseNumber, productId: productId, productViewId: productViewId, productPrice: productPrice, productName: productName, productQtd: productQtd})
        }
        return {error:false}
      } catch(e) {
        console.log(e)
        return {error:false}
      }
    },

}